import { render } from "./DeductDetail.vue?vue&type=template&id=002f6b4c&scoped=true"
import script from "./DeductDetail.vue?vue&type=script&lang=js"
export * from "./DeductDetail.vue?vue&type=script&lang=js"

import "./DeductDetail.vue?vue&type=style&index=0&id=002f6b4c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-002f6b4c"],['__file',"src/views/qywx/crm/kpi/DeductDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "002f6b4c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('002f6b4c', __exports__)) {
    api.reload('002f6b4c', __exports__)
  }
  
  module.hot.accept("./DeductDetail.vue?vue&type=template&id=002f6b4c&scoped=true", () => {
    api.rerender('002f6b4c', render)
  })

}


export default __exports__